// extracted by mini-css-extract-plugin
export default {"feelings":"feelings_feelings__JdgjP","feelingsRange":"feelings_feelingsRange__aq5Xj","bottom":"feelings_bottom__+sO5R"};